// @flow
import React from "react";
import { localize } from "redux-i18n";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "@components";

type Props = $Exact<{
  headerText: string,
  unsafeHTML?: string | React$Node,
  bodyContent?: React$Node,
  bodyClass?: string,
  confirmBtnColor?: string,
  confirmBtnLabel?: string,
  confirmBtnDisabled?: boolean,
  cancelBtnLabel?: string,
  className?: string,
  onConfirm?: Function,
  onCancel?: Function,
  modalSize?: "fullscreen" | "large" | "normal" | "small",
  ...PropsFromLocalize,
}>;

export class ConfirmationModal extends React.Component<Props> {
  render() {
    return (
      <Modal className={`modal-${this.props.modalSize || "small"} ${this.props.className || ""}`}>
        <ModalHeader toggle={this.props.onCancel || null}>{this.props.headerText}</ModalHeader>
        <ModalBody className={this.props.bodyClass || ""}>
          {this.props.bodyContent ? (
            this.props.bodyContent
          ) : (
            <div
              dangerouslySetInnerHTML={{
                __html: this.props.unsafeHTML,
              }}
            />
          )}
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          {this.props.onCancel ? (
            <Button color="secondary" onClick={this.props.onCancel}>
              {this.props.cancelBtnLabel || this.props.t("CANCEL")}
            </Button>
          ) : null}
          {this.props.onConfirm ? (
            <Button
              onClick={this.props.onConfirm}
              color={this.props.confirmBtnColor || "primary"}
              disabled={this.props.confirmBtnDisabled || false}
            >
              {this.props.confirmBtnLabel || this.props.t("OK")}
            </Button>
          ) : null}
        </ModalFooter>
      </Modal>
    );
  }
}
export default localize()(ConfirmationModal);
